(function () {
  const mqlMobile = window.matchMedia('(max-width: 768px)');
  const mqlTablet = window.matchMedia('(max-width: 1024px)');

  const cardsPerView = () => {
    if (mqlMobile.matches) return 1;
    if (mqlTablet.matches) return 2;
    return 3;
  };

  document.querySelectorAll('[data-brand-recipes-carousel]').forEach((root) => {
    const track = root.querySelector('[data-brand-rc-track]');
    const viewport = root.querySelector('[data-brand-rc-viewport]');
    const prevBtn = root.querySelector('[data-brand-rc-prev]');
    const nextBtn = root.querySelector('[data-brand-rc-next]');
    const cards = root.querySelectorAll('[data-brand-rc-card]');
    const n = cards.length;

    if (!track || n === 0) return;

    let index = 0;

    const maxIndex = () => Math.max(0, n - cardsPerView());

    const applyDesktop = () => {
      const cpv = cardsPerView();
      const step = 100 / cpv;
      let max = Math.max(0, n - cpv);
      if (index > max) index = max;
      track.style.transform = `translateX(-${index * step}%)`;
    };

    const sync = () => {
      if (mqlMobile.matches) {
        track.style.transform = '';
        return;
      }
      applyDesktop();
    };

    prevBtn?.addEventListener('click', () => {
      if (mqlMobile.matches && viewport) {
        const card = cards[0];
        const gap = 20;
        const w = card ? card.getBoundingClientRect().width : 0;
        viewport.scrollBy({ left: -(w + gap), behavior: 'smooth' });
        return;
      }
      const max = maxIndex();
      if (max <= 0) return;
      index = index <= 0 ? max : index - 1;
      applyDesktop();
    });

    nextBtn?.addEventListener('click', () => {
      if (mqlMobile.matches && viewport) {
        const card = cards[0];
        const gap = 20;
        const w = card ? card.getBoundingClientRect().width : 0;
        viewport.scrollBy({ left: w + gap, behavior: 'smooth' });
        return;
      }
      const max = maxIndex();
      if (max <= 0) return;
      index = index >= max ? 0 : index + 1;
      applyDesktop();
    });

    const onResize = () => {
      if (mqlMobile.matches) index = 0;
      sync();
    };

    mqlMobile.addEventListener('change', onResize);
    mqlTablet.addEventListener('change', onResize);
    window.addEventListener('resize', onResize);
    sync();
  });
})();
